import React from 'react';
import PropTypes from 'prop-types';

import { CenteredContainer } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import { Impression } from '@nerdwallet/analytics/react/impression';

import {
  HOMEPAGE as analyticsBase,
  HOMEPAGE_SEGMENT_INSTRUMENTATION,
} from '../../../lib/analytics-constants';

import HomePageReg from '../../home-page-reg/home-page-reg';
import SegmentImpression from '../../segment-impression';

const RegistrationModule = ({ featuredImageDesktop, featuredImageMobile }) => {
  const imageProps = {
    src: featuredImageDesktop,
    alt: `home page background image`,
    backgroundColor: 'transparent',
    role: 'presentation',
    lazy: true,
    sources: [
      {
        srcSet: featuredImageMobile,
        media: `(max-width: 1023px)`,
      },
      {
        srcSet: featuredImageDesktop,
      },
    ],
  };

  return (
    <SegmentImpression
      eventName="Element Impression"
      eventProps={HOMEPAGE_SEGMENT_INSTRUMENTATION.registration_module}
    >
      <Impression
        entityName={analyticsBase.entity_names.registration}
        payload={{
          section_name: analyticsBase.section_name,
          registration_cohort: analyticsBase.cohort,
        }}
      >
        <div className="registration-wrapper">
          <CenteredContainer
            paddingLeft={0}
            paddingRight={0}
            className="registration-module-cont"
          >
            <div className="registration-module">
              <div className="registration-module__text">
                <div className="auth-container">
                  <HomePageReg />
                </div>
                <Image
                  {...imageProps}
                  className="registration-module-image__mobile"
                />
              </div>
            </div>
            <Image {...imageProps} className="registration-module-image" />
          </CenteredContainer>
        </div>
      </Impression>
    </SegmentImpression>
  );
};

RegistrationModule.propTypes = {
  featuredImageDesktop: PropTypes.string,
  featuredImageMobile: PropTypes.string,
};

RegistrationModule.displayName = 'RegistrationModule';

export default RegistrationModule;
